import { STATUS_COLORS, FEATURE_COLORS, FEATURE_FALLBACK } from '../constants/map';

export function getFeatureColor(feature) {
	if (!feature) return STATUS_COLORS.none;
	return FEATURE_COLORS[feature] || FEATURE_FALLBACK;
}

export function computeActivityStatus(act, filterActivityStatus) {
	const status   = act.Status   ?? act.status;
	const rawEnd   = act.EndDate   ?? act.endDate;
	const rawStart = act.StartDate ?? act.startDate;

	// In Closed mode in the grid, BOTH Status='Closed' and Status='Open'+expired
	// are shown as 'closed' — the user thinks of both as "done / no longer active".
	if (filterActivityStatus === 'Closed') {
		if (status === 'Closed') return 'closed';
		if (status === 'Open') {
			const today = new Date().setHours(0, 0, 0, 0);
			const end   = rawEnd ? new Date(rawEnd).getTime() : null;
			if (end !== null && end < today) return 'closed';
		}
		return 'none';
	}

	// Open mode
	if (status !== 'Open') return 'none';
	const today = new Date().setHours(0, 0, 0, 0);
	const end   = rawEnd ? new Date(rawEnd).getTime() : null;
	if (end !== null && end < today) return 'none';
	const start = rawStart ? new Date(rawStart).getTime() : null;
	if (start !== null && start <= today) return 'inprogress';
	return 'planned';
}

export function computeStatus(site, displayStart, displayEnd, filterActivityStatus) {
	if (!site.activitiesCount || site.activitiesCount === 0) return 'none';

	const hasOv  = site.hasOverdue ?? site.HasOverdue ?? false;
	const dStart = displayStart ? new Date(displayStart).getTime() : null;
	const dEnd   = displayEnd   ? new Date(displayEnd).getTime()   : null;

	// ── CLOSED MODE ──────────────────────────────────────────────────────────
	// HasOverdue covers Status='Closed' AND Status='Open' with EndDate < today.
	if (filterActivityStatus === 'Closed') {
		return hasOv ? 'overdue' : 'none';
	}

	// ── OPEN MODE ────────────────────────────────────────────────────────────
	// Only show sites with currently-active Open activities.
	// Sites where all Open activities have expired → 'none' in Open mode.
	// Those sites are only visible in Closed mode.
	const aStart = site.activityStartDate ? new Date(site.activityStartDate).getTime() : null;
	const aEnd   = site.activityEndDate   ? new Date(site.activityEndDate).getTime()   : null;

	if (aStart === null && aEnd === null) return 'none';

	const inWindow = (!dStart || aEnd === null || aEnd   >= dStart)
	              && (!dEnd   || aStart === null || aStart <= dEnd);

	if (!inWindow)                            return 'none';
	if (site.activityStatus !== 'Open')       return 'none';

	const todayMs = new Date().setHours(0, 0, 0, 0);
	if (aEnd !== null && aEnd < todayMs)      return 'none';
	if (aStart !== null && aStart <= todayMs) return 'inprogress';
	if (aStart !== null && aStart  > todayMs) return 'planned';
	return 'none';
}

export function computeOverdue(site) {
	if (site.hasOverdue != null) return site.hasOverdue;
	if (site.HasOverdue != null) return site.HasOverdue;
	if (!site.activitiesCount || site.activitiesCount === 0) return false;
	const todayMs = new Date().setHours(0, 0, 0, 0);
	if (site.activityStatus !== 'Open') return true;
	const aEnd = site.activityEndDate ? new Date(site.activityEndDate).getTime() : null;
	if (aEnd !== null && aEnd < todayMs) return true;
	return false;
}

export function normaliseSite(site, displayStart, displayEnd, filterActivityStatus) {
	const feature = site.dominantFeature  != null ? site.dominantFeature
		: site.DominantFeature  != null ? site.DominantFeature
			: site.dominant_feature != null ? site.dominant_feature
				: site.Feature          != null ? site.Feature
					: null;
	const title = site.dominantTitle  != null ? site.dominantTitle
		: site.DominantTitle  != null ? site.DominantTitle
			: null;
	// Backend sends Titles as a pipe-separated string of all activity titles for this site.
	// Parse to array for the canvas filter (a site matches if ANY of its titles is selected).
	const rawTitles = site.titles ?? site.Titles ?? null;
	const titles    = rawTitles
		? String(rawTitles).split('|').map((t) => t.trim()).filter(Boolean)
		: (title ? [title] : []);
	return {
		...site,
		tac:      site.tac != null ? site.tac : site.tAC,
		_status:  computeStatus(site, displayStart, displayEnd, filterActivityStatus),
		_feature: feature,
		_title:   title,
		_titles:  titles,
		_overdue: computeOverdue(site),
	};
}